import MinimumAgeForm from "@/app/components/cart/MinimumAgeForm.vue";
import { VueContentPopover } from "@/app/popover/VueContentPopover";

export class MinimumAgePopover extends VueContentPopover {
    constructor(age: number, confirmHandler: { () }) {
        super({ popoverClass: "minage", fullscreen: false });

        this.initComponent(MinimumAgeForm, {
            age: age,
            confirm: confirmHandler,
            hide: () => {
                this.hide();
            },
        });
    }
}
